import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';

const faqs = [
  {
    question: 'Is HamaraBillBook suitable for small businesses?',
    answer: 'Yes, HamaraBillBook is specially designed for Indian small and medium businesses like shops, traders, distributors, and service providers.'
  },
  {
    question: 'Is the software GST-compliant?',
    answer: 'Absolutely. HamaraBillBook allows you to generate GST-compliant invoices, e-Invoices, and e-Way bills as per government guidelines.'
  },
  {
    question: 'Do I need accounting knowledge to use it?',
    answer: 'Not at all. The app is simple and beginner-friendly. You can start billing without any prior accounting experience.'
  },
  {
    question: 'Can I use HamaraBillBook in my regional language?',
    answer: 'Yes! HamaraBillBook supports multiple Indian languages including Hindi, Tamil, Telugu, and more - making it easy for everyone to use.'
  },
  {
    question: 'Is my business data safe?',
    answer: 'Yes. All your data is securely encrypted and backed up on the cloud. Only you have access to it.'
  },
  {
    question: 'Can I access HamaraBillBook on mobile?',
    answer: 'Yes. You can use HamaraBillBook on Android, iOS, and desktop. Your data stays synced across all devices.'
  }
];

const FAQ = () => (
  <section className="section faq__v2" id="faq">
    <Container>
      <Row className="mb-4">
        <Col md={6} lg={7} className="mx-auto text-center">
          <span className="subtitle text-uppercase mb-3">FAQ</span>
          <h2 className="h2 fw-bold mb-3">Frequently Asked Questions</h2>
          <p>Utilize our tools to develop your concepts and bring your vision to life. Once complete, effortlessly share your creations.</p>
        </Col>
      </Row>
      <Row>
        <Col md={8} className="mx-auto">
          <Accordion defaultActiveKey="0">
            {faqs.map((faq, idx) => (
              <Accordion.Item eventKey={String(idx)} key={idx}>
                <Accordion.Header>{faq.question}</Accordion.Header>
                <Accordion.Body>{faq.answer}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Col>
      </Row>
    </Container>
  </section>
);

export default FAQ; 